import * as T from './actionTypes';

export const fetchAssetTCO = (assetId) => ({ type: T.FETCH_ASSET_TCO, payload: assetId });
export const fetchAssetTCOSuccess = (tco) => ({ type: T.FETCH_ASSET_TCO_SUCCESS, payload: tco });
export const fetchAssetTCOFail = (error) => ({ type: T.FETCH_ASSET_TCO_FAIL, payload: error });
export const clearAssetTCO = () => ({ type: T.CLEAR_ASSET_TCO });
